import { ReactNode } from 'react';

type NsListProps = {
  children?: ReactNode[];
  type?: 'ul' | 'ol';
  className?: 'ul-bullet' | 'ul-ticked' | 'ul-crossed' | 'ol-numbered';
  testId?: string;
  slot?: string;
};

export const NsList = ({
  children = [],
  type: Tag = 'ul',
  className = 'ul-bullet',
  testId = 'listTestId',
  slot
}: NsListProps) => {
  return (
    <Tag className={className} data-testid={testId} slot={slot}>
      {children.map((text, index) => text && <li key={index}>{text}</li>)}
    </Tag>
  );
};
